<template>
  <a-modal
    :title="`数据权限 - ${position.name || ''}`"
    :visible="visible"
    :footer="null"
    width="760px"
    @cancel="close"
  >
    <a-alert
      type="info"
      show-icon
      style="margin-bottom: 12px"
      message="岗位默认权限的值只能是变量（${userId}/${deptId}）或通配符（*）；固定目标值请到「用户特殊权限」按人授予"
    />

    <!-- 新增配置 -->
    <div class="add-bar">
      <a-select
        v-model="addForm.code"
        show-search
        allow-clear
        option-filter-prop="children"
        placeholder="选择数据权限定义"
        style="width: 280px"
      >
        <a-select-option v-for="item in dpList" :key="item.code" :value="item.code">
          {{ item.code }}（{{ item.name }}）
        </a-select-option>
      </a-select>
      <a-input
        v-model="addForm.value"
        placeholder="权限值，如 ${userId}、${deptId}、* 或具体值（逗号分隔多值）"
        style="width: 260px"
      />
      <a-button type="primary" :disabled="!addForm.code || !addForm.value" :loading="adding" @click="add">
        添加
      </a-button>
    </div>

    <a-divider style="margin: 12px 0" />

    <a-table
      bordered
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :dataSource="list"
      :pagination="false"
    >
      <template slot="codeCol" slot-scope="text">
        {{ text }}<span v-if="codeNameMap[text]">（{{ codeNameMap[text] }}）</span>
      </template>
      <template slot="actionCol" slot-scope="text, record">
        <a class="danger-link" @click="removePerm(record)">删除</a>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import {
  fetchPositionDataPerms,
  addPositionDataPerm,
  deletePositionDataPerm,
  fetchDataPermissionList,
} from "@/api/setting/auth";

export default {
  name: "position-dp-modal",

  props: {
    visible: { type: Boolean, default: false },
    // 岗位对象（需要id、name）
    position: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      loading: false,
      adding: false,
      list: [],
      dpList: [],
      addForm: { code: undefined, value: undefined },
      columns: [
        { title: "权限编码", dataIndex: "dataPermissionCode", width: 260, scopedSlots: { customRender: "codeCol" } },
        { title: "权限值", dataIndex: "dataPermissionValue", ellipsis: true },
        { title: "备注", dataIndex: "remarks", width: 160, ellipsis: true },
        { title: "操作", width: 70, align: "center", scopedSlots: { customRender: "actionCol" } },
      ],
    };
  },

  computed: {
    codeNameMap() {
      const map = {};
      this.dpList.forEach((item) => {
        map[item.code] = item.name;
      });
      return map;
    },
  },

  watch: {
    visible(val) {
      if (val) {
        this.addForm = { code: undefined, value: undefined };
        this.load();
        this.loadDefines();
      }
    },
  },

  methods: {
    load() {
      if (!this.position.id) {
        return;
      }
      this.loading = true;
      fetchPositionDataPerms(this.position.id)
        .then((res) => {
          this.list = Array.isArray(res) ? res : [];
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    loadDefines() {
      if (this.dpList.length > 0) {
        return;
      }
      fetchDataPermissionList()
        .then((res) => {
          this.dpList = Array.isArray(res) ? res : [];
        })
        .catch(() => {});
    },
    add() {
      this.adding = true;
      addPositionDataPerm({
        positionId: this.position.id,
        dataPermissionCode: this.addForm.code,
        dataPermissionValue: this.addForm.value,
      })
        .then(() => {
          this.$message.success("添加成功");
          this.addForm = { code: undefined, value: undefined };
          this.load();
        })
        .catch(() => {})
        .finally(() => {
          this.adding = false;
        });
    },
    removePerm(record) {
      const that = this;
      this.$confirm({
        title: "确认删除该条数据权限配置吗？",
        onOk() {
          return deletePositionDataPerm(record.id).then(() => {
            that.$message.success("删除成功");
            that.load();
          });
        },
      });
    },
    close() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped>
.add-bar {
  display: flex;
  align-items: center;
  gap: 12px;
}
.danger-link {
  color: #f5222d;
}
</style>
